import React from 'react';

import brandBanner from "./images/logo.png"
import CalendarChart from "./calendar";

import './styles/dashboard.css';

export default class Dashboard extends React.Component {
    render() {
        let toDate = new Date();
        let fromDate = new Date(toDate.getFullYear()-1, 0, 0);
        let wlbData = [];
        for (var d = fromDate; d <= toDate; d.setDate(d.getDate() + 1)) {
            wlbData.push(
                {
                    "day": d.toISOString().slice(0, 10),
                    "value": Math.random() < 0.12 ? 1: 0
                }
            );
        }
        
        return (
            <div className="row-fluid">
                <br></br>
                <img src={brandBanner} className="img-fluid" style={{ height: "64px" }}></img>
                <br></br><br></br>
                <p>
                    On SkillEd, you can make new friends and learn new skills along the way. You can also mentor others in things you are good at. With SkillEd, we bring the personal touch to skill sharing.
                </p>
                <h3>Upcoming Sessions</h3>
                <div className="row-fluid">
                    <div className="row" style={{ marginTop: "50px" }}>
                        <div className="col-sm-2" style={{ color: "#2b8cbe" }}><i className="fa fa-hands-helping big"></i></div>
                        <div className="col-sm-10">
                            <h4>Karate with Shrija Mishra</h4>
                            <p>Thursday, March 2, 2020</p>
                        </div>
                        <div className="col-sm-2" style={{ color: "#2b8cbe" }}><i className="fa fa-hands-helping big"></i></div>
                        <div className="col-sm-10">
                            <h4>Poetry with Sheryl Ratnam</h4>
                            <p>Wednesday, March 15, 2020</p>
                        </div>
                    </div>
                </div>
                <hr></hr>
                <h3>Session History</h3>
                <div style={{ height: "360px" }}>
                    <CalendarChart
                        data={wlbData}
                    />
                </div>
                <br></br><br></br><br></br><br></br>
            </div>
        );
    }
}